import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Welcome to Cloudflare Pages</h1>
    </div>
  );
}

export default App;
